import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Nav,
  Tab,
  Spinner,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { get, updateToken } from "../../../helpers/api_helper";
import TutorialTable from "./component/TutorialTable";
import free_tutorial from "../../../Assets/svg/tutorial/free_tutorial.svg";
import TutorialPop from "./component/modals/TutorialPop";
import useCheckPermission from "../../../hooks/useCheckPermission";

const ManageTutorial = () => {
  const token = useSelector((state) => state.login.token);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [tutorialData, setTutorialData] = useState([]);
  const [selectedTutorial, setSelectedTutorial] = useState(null);
  const [activeTab, setActiveTab] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchTutorials = useCallback(
    async (page = 1, paid = "all") => {
      setLoading(true);
      try {
        const skip = (currentPage + page - 1)
        const limit = itemsPerPage;
        const response = await get(
          `/tutorial/list?skip=${skip}&limit=${limit}&paid=${paid}`
        );
        if (response?.success) {
          setTutorialData(response?.data?.items || []);
          setTotalPages(response?.data?.totalPages || 0);
        } else {
          console.log("Failed to fetch Tutorials");
          setTutorialData([]);
        }
      } catch (error) {
        console.log(error);
        setTutorialData([]);
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage]
  );

  useEffect(() => {
    if (token) {
      updateToken(token);
      const paidStatus = activeTab === "All" ? "all" : activeTab === "Free" ? false : true;
      fetchTutorials(currentPage, paidStatus);
    }
  }, [token, fetchTutorials, currentPage, activeTab]);

  const handleAddTutorial = () => {
    setModalMode("create");
    setSelectedTutorial(null);
    setShowModal(true);
  };

  const handleEditTutorial = (tutorial) => {
    setSelectedTutorial(tutorial);
    setModalMode("edit");
    setShowModal(true);
  };

  const handleTabChange = (status) => {
    setActiveTab(status);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <>
      <TutorialPop
        showModal={showModal}
        setShowModal={setShowModal}
        setRefresh={() => {
          const paidStatus = activeTab === "All" ? "all" : activeTab === "Free" ? false : true;
          fetchTutorials(currentPage, paidStatus);
        }}
        mode={modalMode}
        tutorialData={selectedTutorial}
        resetFormOnClose={showModal}
      />
      <section className="userSec position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
                <div className="left">
                  <h4 className="m-0 fw-bold">Manage Tutorial Details</h4>
                  <p className="m-0 text-muted py-1">
                    Manage your tutorial content here.
                  </p>
                </div>
                <div className="right d-flex align-items-center flex-wrap gap-10">
                  {useCheckPermission("manageTutorial", "CREATE") && <Button
                    onClick={handleAddTutorial}
                    className="d-flex align-items-center justify-content-center rounded-pill"
                    variant="transparent"
                  >
                    <span className="icn me-2">
                      <img src={free_tutorial} alt="" />
                    </span>
                    Add New Tutorial
                  </Button>}
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                activeKey={activeTab}
                onSelect={(k) => handleTabChange(k)}
              >
                <div className="commonTable scrollable-table-container">
                  <div
                    className="top px-3 pt-2 d-flex align-items-center justify-content-between gap-10"
                    style={{ background: "#F5F7FA" }}
                  >
                    <div className="left">
                      <Nav
                        variant="pills"
                        className="transparentBtn-Tab py-2 gap-10"
                      >
                        <Nav.Item>
                          <Nav.Link
                            eventKey="All"
                            className="p-0 bg-transparent px-2"
                          >
                            All
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="Free"
                            className="p-0 bg-transparent px-2"
                          >
                            Free
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="Paid"
                            className="p-0 bg-transparent px-2"
                          >
                            Paid
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                  </div>
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "100px" }}
                    >
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  ) : tutorialData.length > 0 ? (
                    <>
                      <TutorialTable
                        tutorialData={tutorialData}
                        activeTab={activeTab}
                        handleEditTutorial={handleEditTutorial}
                        handlePageChange={handlePageChange}
                        totalPages={totalPages}
                        currentPage={currentPage}
                        setRefresh={fetchTutorials}
                      />
                    </>
                  ) : (
                    <p>No tutorial data available.</p>
                  )}
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageTutorial;
